var path = '/store/rsvps/views/qr-code-modal.tpl.html';
var html = "<button class=\"close\" ng-click=\"vm.close()\"><i class=\"fal fa-times\"></i></button>\n<div class=\"modal-header\">\n    <h2>QR Code</h2>\n</div>\n<div class=\"modal-content-inner\">\n    <div class=\"modal-body\" style=\"text-align: center;\">\n        <qrcode data=\"{{vm.code}}\" size=\"200\"></qrcode>\n    </div>\n</div>\n\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/store/rsvps/views/qr-code-modal.tpl.html
// module id = 2348
// module chunks = 1